"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unsubscribeAction = exports.subscribeAction = exports.leaveGroupAction = exports.joinGroupAction = exports.getInviteState = exports.default = exports.cssAnchorName = exports.checkUserSubscribed = exports.TopicsList = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _common = require("@insided/shared/utils/common");

var _TopicListItemView = _interopRequireDefault(require("@insided/deprecated-preact-components/topic-list-view/TopicListItemView.sync"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _axios = _interopRequireDefault(require("axios"));

var _mixpanelEventsFromDestination = require("@insided/deprecated-preact-components/utils/mixpanelEventsFromDestination");

var _Pagination = _interopRequireDefault(require("@insided/shared/uikit/Pagination"));

var _urlGenerator = require("@insided/deprecated-preact-components/utils/urlGenerator");

var _PrivateGroupPlaceholder = _interopRequireDefault(require("@insided/destination/modules/Groups/PrivateGroupPlaceholder"));

var _PrivateGroupPlaceholderV = _interopRequireDefault(require("@insided/destination/modules/Groups/PrivateGroupPlaceholderV2"));

var _GroupV = _interopRequireDefault(require("@insided/destination/modules/Groups/GroupV2"));

var _GroupV2 = _interopRequireDefault(require("@insided/destination/modules/Groups/GroupV1"));

var _TopicAdd = _interopRequireDefault(require("@insided/destination/icons/TopicAdd"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _publish = _interopRequireDefault(require("@insided/deprecated-components/tracker/publish"));

var cssAnchorName = 'group-detail';
exports.cssAnchorName = cssAnchorName;

var getInviteState = function getInviteState(inviteStatus) {
  switch (inviteStatus) {
    case 'ok':
      return {
        type: 'success',
        message: 'groups.invite.joined'
      };

    case 'fail:invalid-invite':
      return {
        type: 'error',
        message: 'groups.invite.invalid_link'
      };

    case 'fail:invalid-user-role':
      return {
        type: 'error',
        message: 'groups.invite.invalid_role'
      };

    default:
      return null;
  }
};

exports.getInviteState = getInviteState;

var pageReload = function pageReload() {
  if (_common.common.isModuleActive('groupsV2')) {
    window.location.reload();
  }
};

var joinGroupAction = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
    var groupId, csrfToken, isPrivateGroup, onLoadSuccess, setState, userId, event;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            groupId = _ref.groupId, csrfToken = _ref.csrfToken, isPrivateGroup = _ref.isPrivateGroup, onLoadSuccess = _ref.onLoadSuccess, setState = _ref.setState;
            userId = (0, _insidedDataStorage.getInsidedData)('user').userid;

            if (userId) {
              _context.next = 6;
              break;
            }

            event = new window.CustomEvent('GuestUserAction');
            window.dispatchEvent(event);
            return _context.abrupt("return");

          case 6:
            setState({
              isLoading: true
            });
            _context.prev = 7;
            _context.next = 10;
            return _axios.default.post("/group/".concat(groupId, "/join"), {
              csrfToken: csrfToken
            });

          case 10:
            setState({
              userJoined: true,
              isLoading: false,
              userSubscribed: true
            });

            _publish.default.trackEvent('userevent', {
              type: 'GroupMemberJoined',
              payload: 'method1',
              userId: userId,
              addedBy: userId
            });

            if (onLoadSuccess) {
              onLoadSuccess();
            }

            if (isPrivateGroup) {
              (0, _mixpanelEventsFromDestination.trackRequestToJoinPrivateGroup)('RequestViaGroupDetailPage', groupId);
            }

            pageReload();
            _context.next = 20;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](7);
            setState({
              isLoading: false
            });

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[7, 17]]);
  }));

  return function joinGroupAction(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.joinGroupAction = joinGroupAction;

var leaveGroupAction = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(groupId, csrfToken, setState) {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            setState({
              isLoading: true
            });
            _context2.prev = 1;
            _context2.next = 4;
            return _axios.default.post("/group/".concat(groupId, "/leave"), {
              csrfToken: csrfToken
            });

          case 4:
            setState({
              userJoined: false,
              isLoading: false
            });
            pageReload();
            _context2.next = 11;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);
            setState({
              isLoading: false
            });

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 8]]);
  }));

  return function leaveGroupAction(_x2, _x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

exports.leaveGroupAction = leaveGroupAction;

var subscribeAction = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(groupId, csrfToken, setState) {
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            setState({
              isLoading: true
            });
            _context3.prev = 1;
            _context3.next = 4;
            return _axios.default.post("/subscribers/group/".concat(groupId), {
              csrfToken: csrfToken
            });

          case 4:
            setState({
              isLoading: false,
              userSubscribed: true
            });
            _context3.next = 10;
            break;

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](1);
            setState({
              isLoading: false
            });

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 7]]);
  }));

  return function subscribeAction(_x5, _x6, _x7) {
    return _ref4.apply(this, arguments);
  };
}();

exports.subscribeAction = subscribeAction;

var unsubscribeAction = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(groupId, csrfToken, setState) {
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            setState({
              isLoading: true
            });
            _context4.prev = 1;
            _context4.next = 4;
            return _axios.default.delete("/subscribers/group/".concat(groupId), {
              data: {
                csrfToken: csrfToken
              }
            });

          case 4:
            setState({
              isLoading: false,
              userSubscribed: false
            });
            _context4.next = 10;
            break;

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](1);
            setState({
              isLoading: false
            });

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 7]]);
  }));

  return function unsubscribeAction(_x8, _x9, _x10) {
    return _ref5.apply(this, arguments);
  };
}();

exports.unsubscribeAction = unsubscribeAction;

var checkUserSubscribed = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(groupId, setState) {
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return _axios.default.get("/subscribers/group/".concat(groupId));

          case 3:
            setState({
              userSubscribed: true
            });
            _context5.next = 9;
            break;

          case 6:
            _context5.prev = 6;
            _context5.t0 = _context5["catch"](0);
            setState({
              userSubscribed: false
            });

          case 9:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 6]]);
  }));

  return function checkUserSubscribed(_x11, _x12) {
    return _ref6.apply(this, arguments);
  };
}();

exports.checkUserSubscribed = checkUserSubscribed;

var TopicsList = function TopicsList(props) {
  var isFrontendModerationEnabled = _common.common.isModuleActive('frontendContentModeration') && props.isCurrentUserModerator;

  var isGroupV2Active = _common.common.isModuleActive('groupsV2');

  return (0, _preact.h)("div", {
    className: "list-widget-wrapper"
  }, props.canSee && !!props.topics.length ? (0, _preact.h)("div", null, props.topics.map(function (topic) {
    return (0, _preact.h)(_TopicListItemView.default, {
      key: topic.privateId,
      topic: topic,
      attachmentCdn: props.attachmentCdn,
      hideCategoryMetadata: true,
      isFrontendModerationEnabled: isFrontendModerationEnabled
    });
  }), props.totalPagesCount > 1 ? (0, _preact.h)(_Pagination.default, {
    totalPageCount: props.totalPagesCount,
    currentPage: props.currentPage,
    generateNewUrl: _urlGenerator.generateNewUrl
  }) : null) : null, props.canSee && !props.topics.length && isGroupV2Active ? (0, _preact.h)("div", {
    className: "group-private__placeholder groups-v2-styles"
  }, (0, _preact.h)("div", {
    className: "group-content-container"
  }, (0, _preact.h)("div", null, (0, _preact.h)(_TopicAdd.default, {
    className: "icon-topic-add"
  }), (0, _preact.h)("h3", null, (0, _preact.h)(_phrase.default, {
    p: "groups.no.topics.yet"
  })), (0, _preact.h)("p", null, (0, _preact.h)(_phrase.default, {
    p: "groups.information.no.topics.description"
  }))))) : null, !props.canSee && isGroupV2Active ? (0, _preact.h)(_PrivateGroupPlaceholderV.default, {
    onRequest: props.requestJoin,
    isLoading: props.isLoading,
    requestPending: props.requestSent
  }) : null, !props.canSee && !isGroupV2Active ? (0, _preact.h)(_PrivateGroupPlaceholder.default, {
    onRequest: props.requestJoin,
    isLoading: props.isLoading,
    requestPending: props.requestSent
  }) : null);
};

exports.TopicsList = TopicsList;

var Group = function Group(props) {
  return _common.common.isModuleActive('groupsV2') ? (0, _preact.h)(_GroupV.default, props) : (0, _preact.h)(_GroupV2.default, props);
};

var _default = Group;
exports.default = _default;